<template>
  <div class="content">
    <div class="content-left">
      <div class="aside-top">
        <div>
          <span class="SourceHanSansCN-Regular" style="font-size: 16px;">支护列表</span>
          <!-- <span class="el-icon-caret-bottom" style="margin-left: 10px;"></span> -->
        </div>
        <div class="button" @click="addFoundation">添加</div>
      </div>
      <div class="aside-list">
        <div class="foundation-item" v-for="item in list" :key="item.id" :class="[item.id == id?'foundation-item-active': '', item.status == 1? 'bg-color1' : 'bg-color2']" @click="changeId(item.id)">
          <div class="item-left">
            <div class="nowrap" style="text-align: left;font-size: 14px;margin-bottom: 10px;">{{ item.name }}</div>
            <div v-if="item.status == 1" style="text-align: left;font-size: 14px;">在建</div>
            <div v-else-if="item.status == 2" style="text-align: left;font-size: 14px;">已拆除</div>
          </div>
          <div>
            <p class="button" style="color: #8EA3CE;border:1px solid rgba(153, 153, 153, 0.8);margin-bottom: 5px" @click="updateSupport(item)">编辑</p>
            <p class="button button-red" style="border: 1px solid #F7A7A7;color: #F7A7A7;" @click="deleteSupport(item)">删除</p>
          </div>
        </div>
      </div>
    </div>
    <div id="content-right" class="content-right">
      <div class="foundation-detail">
        <p class="title">支护详情</p>
        <div class="info">
          <el-row style="text-align: left;">
            <el-col :span="8" class="overflow-1" style="font-size: 14px;"><span style="color: #666;width: 6vw;text-align-last: justify;display: inline-block;">支护名称</span>：<span style="color: #333">{{currentList.name}}</span></el-col>
            <el-col :span="8" style="font-size: 14px;"><span style="color: #666;width: 6vw;text-align-last: justify;display: inline-block;">支护状态</span>：<span v-if="currentList.status == 1" style="color: green">在建</span>
            <span v-else-if="currentList.status == 2" style="color: red">已拆除</span></el-col>
            <el-col :span="8" class="overflow-1" style="font-size: 14px;"><span style="color: #666;width: 6vw;text-align-last: justify;display: inline-block;">备注</span>：<span style="color: #333">{{currentList.remark}}</span></el-col>
          </el-row>
          <el-row style="margin-top: 24px;text-align: left;">
            <el-col :span="8" style="font-size: 14px;"><span style="color: #666;width: 6vw;text-align-last: justify;display: inline-block;">支护安全等级</span>：<span style="color: #333" v-if="currentList.safeLevel == 1">一级</span>
            <span style="color: #333" v-if="currentList.safeLevel == 2">二级</span><span style="color: #333" v-if="currentList.safeLevel == 3">三级</span></el-col>
            <el-col :span="8" style="font-size: 14px;"><span style="color: #666;width: 6vw;text-align-last: justify;display: inline-block;">施工开始时间</span>：<span style="color: #333">{{currentList.workDate}}</span></el-col>
          </el-row>
        </div>
      </div>

      <div class="main-engine-list">
        <div class="title" style="display: flex;justify-content: space-between;">
          <p style="font-size: 16px">支护主机列表</p>
          <p>
            <el-button size="mini" style="border-radius: 6px;" class="button2" @click="toHistory">历史数据</el-button>
            <el-button size="mini" style="border-radius: 6px;" @click="addHost" class="button2">添加</el-button>
          </p>
        </div>
        <div class="table">
          <el-table :data="hostData" border style="font-family: SourceHanSansCN-Regular;font-size: 18px;color: #909399;position: relative;" :header-cell-style="tableHeaderStyle"
          @expand-change="expandChange" :row-key="getRowKey" :expand-row-keys="expands">
            <el-table-column label="序号" width="70" align="center" type="index" :index="1"></el-table-column>
            <el-table-column label="名称">
              <template slot-scope="scope">
                <span>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column label="设备号">
              <template slot-scope="scope">
                <span>{{scope.row.dtuImei}}</span>
              </template>
            </el-table-column>
            <el-table-column label="设备状态">
              <template slot-scope="scope">
                 <span v-if="scope.row.online == '在线'" style="color:#10B33B">{{scope.row.online}}</span>
                 <span v-else style="color:#EC0F0F">{{scope.row.online}}</span>
              </template>
            </el-table-column>
            <el-table-column label="压力传感器">
              <template slot-scope="scope">
                <span>{{scope.row.pressureCount.split('_')[0]}}</span>
              </template>
            </el-table-column>
              <el-table-column label="位移传感器">
              <template slot-scope="scope">
                <span>{{scope.row.displacementCount.split('_')[0]}}</span>
              </template>
            </el-table-column>
              <el-table-column label="倾角传感器">
              <template slot-scope="scope">
                <span>{{scope.row.dipangleCount.split('_')[0]}}</span>
              </template>
            </el-table-column>
             <el-table-column type="expand" look="查看" width="80">
              <template slot-scope="scope">
                <div class="expand-top">
                  <!-- <span class="el-icon-caret-bottom" style="position: absolute;right: 6vw;top: -2.5vh;font-size: 20px;color: #4D6EB1"></span> -->
                  <p>{{scope.row.name}}传感器列表</p>
                 <div>
                   <el-button size="small" class="button2" style="border-radius: 6px;" @click="addSensor">添加</el-button>
                 </div>
                </div>
                <el-table :data="sensorList" border style="font-family: SourceHanSansCN-Regular;font-size: 18px;color: #909399;">
                  <el-table-column label="序号" width="80" align="center" type="index" :index="1"></el-table-column>
                  <el-table-column label="名称">
                    <template slot-scope="scope">
                      <span>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="设备号">
                    <template slot-scope="scope">
                      <span>{{scope.row.tsSersorImei}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="设备状态">
                    <template slot-scope="scope">
                      <span v-if="scope.row.online == '在线'" style="color:#10B33B">{{scope.row.online}}</span>
                      <span v-else style="color:#EC0F0F">{{scope.row.online}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="设备类型">
                    <template slot-scope="scope">
                      <span>{{scope.row.tsSersorTypeName}}</span>
                    </template>
                  </el-table-column>
                   <el-table-column label="实时数据">
                    <template slot-scope="scope">
                      <span v-if="scope.row.tsSersorTypeName == '位移'">{{scope.row.nowValue || 0}}/mm</span>
                      <span v-else-if="scope.row.tsSersorTypeName == '倾角'">{{scope.row.nowValue || 0}}/°</span>
                      <span v-else-if="scope.row.tsSersorTypeName == '压力'">{{scope.row.nowValue || 0}}/kg</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="预警值">
                    <template slot-scope="scope">
                      <span v-if="scope.row.tsSersorTypeName == '位移'">{{scope.row.warning || 0}}/mm</span>
                      <span v-else-if="scope.row.tsSersorTypeName == '倾角'">{{scope.row.warning || 0}}/°</span>
                      <span v-else-if="scope.row.tsSersorTypeName == '压力'">{{scope.row.warning || 0}}/kg</span>
                    </template>
                  </el-table-column>
                   <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                      <span class="table-button" style="color: #8EA3CE;margin-right: 5px;" @click="updateSensor(scope.row)">编辑</span>
                      <span class="table-button button-red" style="border: 1px solid #F7A7A7;color: #F7A7A7;" @click="deleteSensor(scope.row)">删除</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200" >
              <template slot-scope="scope">
                <div style="position: relation;left: -18px">
                  <span class="table-button" style="color: #8EA3CE;border:1px solid rgba(153, 153, 153, 0.8);margin-right: 5px" @click="updateHost(scope.row)">编辑</span>
                  <span class="table-button" style="color: #8EA3CE;border:1px solid rgba(153, 153, 153, 0.8);margin-right: 5px" @click="setValue(scope.row)">设置</span>
                  <span class="table-button button-red" style="border: 1px solid #F7A7A7;color: #F7A7A7;" @click="deleteHost(scope.row)">删除</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

     <div class="five-icons">
        <div>
          <div style="margin-top: 20px"><img src="../../../assets/image/foundation/abnormal.png"></div>
          <div class="icon-item-right">
            <p>{{count.todayWarningCount || 0}}</p>
            <p>今日异常</p>
          </div>
        </div>
        <div>
           <div style="margin-top: 20px"><img src="../../../assets/image/foundation/monitor.png"></div>
          <div class="icon-item-right">
            <p>{{count.sum || 0}}</p>
            <p>监测点位</p>
          </div>
        </div>
        <div>
           <div style="margin-top: 20px"><img src="../../../assets/image/foundation/on-line.png"></div>
          <div class="icon-item-right">
            <p>{{count.online || 0}}</p>
            <p>在线设备</p>
          </div>
        </div>
        <div>
           <div style="margin-top: 20px"><img src="../../../assets/image/foundation/off-line.png"></div>
          <div class="icon-item-right">
            <p>{{count.offline || 0}}</p>
            <p>离线设备</p>
          </div>
        </div>
        <div>
           <div style="margin-top: 20px"><img src="../../../assets/image/foundation/alarm.png"></div>
          <div class="icon-item-right">
            <p>{{count.warningPointCnt || 0}}</p>
            <p>点位报警</p>
          </div>
        </div>
     </div>

      <!-- 支护压力监测 -->
     <div class="liquid-level-gauge">
        <div class="title" style="display: flex;justify-content: space-between;">
          <p style="font-size: 16px">支护压力监测</p>
          <p>{{currentData3.name}}</p>
        </div>
        <div style="height: 380px;width: 69vw" ref="chart3"></div>
        <span class="el-icon-arrow-left" @click="left3"></span>
        <span class="el-icon-arrow-right" @click="right3"></span>
     </div>

     <!-- 支护倾角监测 -->
     <div class="liquid-level-gauge">
        <div class="title" style="display: flex;justify-content: space-between;">
          <p style="font-size: 16px">支护倾角监测</p>
          <p>{{currentData2.name}}</p>
        </div>
        <div style="height: 380px;width: 69vw" ref="chart2"></div>
        <span class="el-icon-arrow-left" @click="left2"></span>
        <span class="el-icon-arrow-right" @click="right2"></span>
     </div>

     <!-- 支护位移监测 -->
     <div class="inclinometer">
        <div class="title" style="display: flex;justify-content: space-between;">
          <p style="font-size: 16px">支护位移监测</p>
          <p>{{currentData1.name}}</p>
        </div>
        <div style="height: 380px;width: 69vw" ref="chart1"></div>
        <span class="el-icon-arrow-left" @click="left1"></span>
        <span class="el-icon-arrow-right" @click="right1"></span>
     </div>

      <div class="foundation-ichnography">
        <p class="title">支护监测平面图</p>
        <div class="foundation-ichnography-img"
        style="-webkit-user-select:none;
       user-select:none;" id="box5-cont">
          <div v-if="currentList.planarGraph" id="cebian" class="cebian">
            <div @click="openIsShow">
              <i v-if="isShow" style="color:#fff;cursor: pointer;" class="el-icon-d-arrow-left"></i>
              <i v-else style="color:#fff;cursor: pointer;" class="el-icon-d-arrow-right"></i>
            </div>
          </div>
          <div v-if="currentList.planarGraph" class="cebian-item" v-for="(item,index) in testList" @mousedown="btnclick(item)" :id="item.id" :key="index">
            {{item.name}}
          </div>
          <div v-if="currentList.planarGraph" class="iconFt" :style="'left:'+item.left+';'+'top:'+item.top" :id="'a'+item.id" v-for="(item,index) in iconList">
            <div>{{item.name}}</div>
            <div></div>
            <div><i style="color:#f00" class="el-icon-error" @click="deleteByIdDW(item.id)"></i></div>
          </div>
          <img v-if="currentList.planarGraph" :src="httpCtx + currentList.planarGraph + '?time=' + new Date().getTime()" style="height: 100%;width: 100%">
          <span v-else style="text-align: center;font-size: 16px">暂无图片</span>
        </div>
      </div>
    </div>

    <!-- 添加基坑弹出框 -->
    <el-dialog
      :visible.sync="foundationDialog"
      width="650px"
      center>
      <p slot="title" class="dialog-title">支护信息</p>
      <el-form :model="addForm" ref="ruleForm" :rules="rules" label-position="right" label-width="200px">
        <el-form-item label="支护名称：" prop="name">
          <el-input v-model="addForm.name" size="medium" placeholder="请输入支护名称"></el-input>
        </el-form-item>
        <el-form-item label="支护状态：" prop="status">
          <el-select v-model="addForm.status" placeholder="请选择支护状态">
            <el-option :value="1" label="在建"></el-option>
            <el-option :value="2" label="已拆除"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支护安全等级：" prop="safeLevel">
          <el-select v-model="addForm.safeLevel" placeholder="请选择支护安全等级">
             <el-option :value="1" label="一级"></el-option>
             <el-option :value="2" label="二级"></el-option>
             <el-option :value="3" label="三级"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="施工开始时间：" prop="workDate">
          <el-date-picker :disabled="isUpdate" v-model="addForm.workDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="addForm.remark" type="textarea" :rows="4" placeholder="请输入备注内容"></el-input>
        </el-form-item>
        <el-form-item label="上传支护平面图：">
          <el-upload
            :action="uploadUrl"
            :headers="uploadHead"
            :data="{type:254}"
            :on-success="successFile"
            :limit="1"
            :show-file-list="false"
            :on-exceed="exceedFile"
            >
            <img style="width: 100px" v-if="fileList.length != 0" :src="httpCtx + fileList[0].url + '?time=' + new Date().getTime()">
            <div v-else class="upload-div"><span class="el-icon-plus" style="color: #DEDEDE;font-size: 60px;"></span></div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="foundationDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')" style="background-color: #4D6EB1">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加主机弹出框 -->
    <el-dialog
      :visible.sync="addHostDialog"
      width="500px"
      center>
      <p slot="title" class="dialog-title">主机信息</p>
       <el-form :model="addHostForm" label-position="right" label-width="120px">
        <el-form-item label="主机名称：">
          <el-input v-model="addHostForm.name" size="medium" placeholder="请输入主机名称"></el-input>
        </el-form-item>
        <el-form-item label="设备编号：">
          <el-input v-model="addHostForm.dtuImei" size="medium" placeholder="请输入设备编号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addHostDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitHostForm" style="background-color: #4D6EB1">确 定</el-button>
      </span>
    </el-dialog>

     <!-- 添加传感器弹出框 -->
    <el-dialog
      :visible.sync="addSensorDialog"
      width="500px"
      center>
      <p slot="title" class="dialog-title">传感器信息</p>
       <el-form :model="addSensorForm" label-position="right" label-width="120px">
        <el-form-item label="传感器名称：">
          <el-input v-model="addSensorForm.name" size="medium" placeholder="请输入传感器名称"></el-input>
        </el-form-item>
        <el-form-item label="传感器编号：">
          <el-input v-model="addSensorForm.tsSersorImei" size="medium" placeholder="请输入设备编号"></el-input>
        </el-form-item>
        <el-form-item label="设备类型：">
          <el-select v-model="addSensorForm.tsSersorType" placeholder="请选择设备类型">
            <el-option :value="1" label="位移"></el-option>
            <el-option :value="2" label="倾角"></el-option>
            <el-option :value="3" label="压力"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addSensorDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitSensorForm" style="background-color: #4D6EB1">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 预警值设置弹出框 -->
    <el-dialog
      :visible.sync="warnValueDialog"
      :close-on-click-modal="false"
      width="500px"
      center>
       <p slot="title" class="dialog-title">预警值设置</p>
       <el-form :model="warnForm" label-position="right" label-width="120px">
        <el-form-item label="预警值：">
          <el-input v-model="warnForm.warningValue" size="medium" placeholder="请输入预警值"></el-input>
        </el-form-item>
        <el-form-item label="传感器类型：">
          <el-select v-model="warnForm.tsSenserType" placeholder="请选择传感器类型">
            <el-option :value="1" label="位移"></el-option>
            <el-option :value="2" label="倾角"></el-option>
            <el-option :value="3" label="压力"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="warnValueDialog = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitWarnForm" style="background-color: #4D6EB1">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        id: '',
        hostId: '',
        hostIdStr: '',
        isUpdate: undefined,
        value1: '',
        projectId: '',
        httpCtx: base.httpCtx,
        uploadUrl: base.url + '/upload/uploadPhoto',
        uploadHead: {
          accessToken: util.session.get('token'),
        },
        fileList: [],
        foundationDialog: false,  // 添加基坑弹出框
        addHostDialog: false,     //添加主机弹出框
        addSensorDialog: false,    // 添加传感器弹出框
        warnValueDialog: false,     // 预警值设置弹出框
        addForm: {
          name: '',
          status: '',
          safeLevel: '',
          workDate: '',
          remark: '',
          planarGraph: '',     // 图片
        },    
        rules: {
          name: [{ required: true, message: '请输入支护名称', trigger: 'blur' }],
          status: [ { required: true, message: '请选择支护状态', trigger: 'blur' }],
          safeLevel: [{ required: true, message: '请选择安全等级', trigger: 'blur' }],  
          workDate: [{ required: true, message: '请选择施工开始时间', trigger: 'blur' }],
        },
        addHostForm: {
          dtuImei: '',
          name: '',
          useType: 2
        },
        hostData: [],     // 主机列表
        list: [],       // 支护列表
        currentList: {},   // 当前的支护列表
        sensorList: [],    /// 传感器列表
        addSensorForm: {
          name: '',
          tsSersorImei: '',
          tsSersorType: ''
        },
        expands: [],   // 要展开的行
        warnForm: {
          warningValue: '',
          tsSenserType: ''
        },   
        count: {},  


        data1: [],   // 位移传感器
        wyData: [],
        warnData1: [],
        time1: [],
        timer1: null,


        data2: [],   // 倾角传感器
        qjData: [[],[]],
        warnData2: [[],[]],
        time2: [],
        timer2: null,



        data3: [],   // 压力传感器
        ylData: [],
        warnData3: [],
        time3: [],
        timer3: null,



        index1: 0,   
        index2: 0,
        index3: 0,
        currentData1: {
          name: ''
        },
        currentData2: {
          name: ''
        },
        currentData3: {
          name: ''
        },
        testList:[
          
        ],
        listItem:{},
        iconList:[],
        isDrag:false,
        isShow:false
      }
    },
    created() {
      const {id} = this.$route.query
      if(id){
        this.id = id
      }
      this.projectId = util.session.get('groupId')
      this.getData()
    },
    mounted() {
      this.initChart1()
      this.initChart2()
      this.initChart3()
    },
    updated(){
      if(this.testList.length!=0){
        this.aaa()
      }
    },
    methods: {
      deleteByIdDW(item){
        console.log('qql')
        myHttp.deleteByIdDW({
          id:item
        }).then(res=>{
          console.log(res)
          this.getSenserByDtuId()
        })
      },
      getByIdentification(){
        let that = this
        myHttp.getByIdentification({
          identification:this.id
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            let dataS = res.data.data
            that.iconList = dataS
            if(that.iconList.length!=0){
              dataS.forEach(item=>{
              item.left = item.location.split(',')[0]
              item.top = item.location.split(',')[1]
              // console.log(item.location.split(','))
              
            })
            that.iconList = dataS
            that.iconList.forEach((item,index)=>{
              that.testList.forEach((itemA,indexA)=>{
                if(item.id==itemA.id){
                  item.name=itemA.name
                  // console.log(item.name,itemA.name)
                  that.testList.splice(indexA,1)
                }
              })
            })
            console.log(dataS,'666')
            }
          }
        })
      },
      openIsShow(){
        this.isShow=!this.isShow
        if(this.isShow){
          document.getElementById('cebian').style.width='12%'
          this.testList.forEach((item,index)=>{
            console.log(item,'adasdd')
                document.getElementById(item.id).style.opacity='1'
              })
        }else{
          document.getElementById('cebian').style.width='0%'
          this.testList.forEach((item,index)=>{
                document.getElementById(item.id).style.opacity='0'
              })
        }
      },
      aaa(){
        if(this.currentList.planarGraph){
          this.testList.forEach((item,indexA)=>{
          let itemA = document.getElementById(item.id)
          // console.log(itemA)
          if(indexA==0){
            itemA.style.top=0+'%'
            return
          }
        itemA.style.top = indexA*8+'%'
      })
        }
      },
			// 点击元素事件
			btnclick(index) {
        console.log(index,'item')
        this.listItem = index
				// 打印ID值
				// 对多个元素绑定拖拽事件，要先点击，然后才能拖拽（先点击获取元素对象）
				var box=document.getElementById(index.id)
				var obox=document.getElementById("box5-cont");
				// 为每个元素加入拖拽事件
				var disX
				  var disY
				  var that = this
				  // 鼠标左键按下事件
				  box.onmousedown=function(ev){
				    var oEvent=ev||event
					// clientX，clientY：鼠标点击位置到浏览器可视区域x，y距离
					// offsetLeft，offsetTop:元素距离父级元素的偏移距离
				    disX=oEvent.clientX - box.offsetLeft
				    disY=oEvent.clientY - box.offsetTop
					that.isDrag = true
					// 鼠标移动事件
				    document.onmousemove=function(ev){
						// 加入该判断拖拽更流畅
						if (that.isDrag) {
              that.testList.forEach((item,index)=>{
                document.getElementById(item.id).style.display='none'
              })
              document.getElementById('cebian').style.display='none'
							var oEvent=ev||event
							  // 计算点击元素到父级元素的定位top，left距离
							  var l=oEvent.clientX-disX
							  var t=oEvent.clientY-disY
							  // 设置拖拽边界(限定在浏览器可视区域（空白区域）之内)
							  // 限定左边界
							  // if(l<0){
							  //   l=0
							  // }else if(l>document.documentElement.clientWidth-box.offsetWidth){
							  //   限定右边界
							  //   l=document.documentElement.clientWidth-box.offsetWidth
							  // }
							  // 限定上边界
							  // if(t<0){
							  //   t=0
							  // }else if(t>document.documentElement.clientHeight-box.offsetHeight){
							  //   限定下边界
							  //   t=document.documentElement.clientHeight-box.offsetHeight
							  // }
							  /** 限定拖拽范围，限定拖拽元素在指定的范围内 */
							  // 限定左边界和上边界
							   if(l<0){
								  l=0;
								}
								if(t<0){
								  t=0;
								}
								// 限定右边界的距离(当l=父元素宽-子元素宽时，刚好子元素放在父元素最右边)
							   if(l>obox.clientWidth - box.clientWidth){
								  l=obox.clientWidth - box.clientWidth
								}
								// 限定下边界的距离(当t=父元素高-子元素高时，刚好子元素放在父元素最下边)
								if(t>obox.clientHeight - box.clientHeight){
								   t = obox.clientHeight - box.clientHeight
								}
                if(that.iconList.length!=0){
                if(that.iconList[that.iconList.length-1].id==that.listItem.id){
                
                }else{
                  that.iconList.push(that.listItem)
                  that.testList.forEach((item,index)=>{
                    if(item.id==that.listItem.id){
                      that.testList.splice(index,1)
                      console.log(that.testList,'1')
                    }
                    // console.log(item.id,that.listItem.id,'1')
                  })
                  
                }
              }else{
                that.iconList.push(that.listItem)
                that.testList.forEach((item,index)=>{
                    if(item.id==that.listItem.id){
                      that.testList.splice(index,1)
                      console.log(that.testList,'2')
                    }
                    console.log(item.id,that.listItem.id,'2')
                  })
              }
                let box5Cont = document.getElementById('box5-cont')
                let SSt = t/box5Cont.clientHeight*100+'%'
                let SSl = l/box5Cont.clientWidth*100+'%'
                // let SSt = t+'px'
                // let SSl = l+'px'
							  
                that.listItem.left = SSl
                that.listItem.top = SSt
							}
						}
				    document.onmouseup=function(){
              document.getElementById('cebian').style.display='block'
              that.testList.forEach((item,index)=>{
                document.getElementById(item.id).style.display='block'
              })
              
				      document.onmousemove=null
				      document.onmouseup=null //鼠标抬起来后，onmouseup事件本身也没意义了，所以最好清理掉
              let iconI = document.getElementById('a'+that.listItem.id)
              iconI.style.left=that.listItem.left
              iconI.style.top=that.listItem.top
              console.log(that.listItem)
              myHttp.createInfoDW({
                projectId:util.session.get('groupId'),
                identification:that.id,
                location:that.listItem.left+','+that.listItem.top,
                createBy:util.session.get('user').id,
                id:that.listItem.id
              }).then(res=>{
                console.log(res)
              })
					  that.isDrag = false
				    }
				    return false //阻止默认行为，空的div在低版本ff下，第二次拖动手型会变异常
				  }
			},
      changeId(id){
        this.isShow=false
        if(this.currentList.planarGraph){
          document.getElementById('cebian').style.width='0%'
          this.testList.forEach((item,index)=>{
                document.getElementById(item.id).style.opacity='0'
              })
        }
        this.id = id
        for(let i=0;i<this.list.length;i++){
           if(id == this.list[i].id){
            this.currentList = this.list[i]
           }
        }
        this.getHostList()

        clearTimeout(this.timer1)
        this.timer1 = null
        clearTimeout(this.timer2)
        this.timer2 = null
        clearTimeout(this.timer3)
        this.timer3 = null

        this.data1 = []
        this.wyData = [],
        this.warnData1 = [],
        this.time1 = [],
        this.data2 = [],  
        this.qjData = [[],[]],
        this.warnData2 = [[]],[],
        this.time2 = [],
        this.data3 = [],  
        this.ylData = [],
        this.warnData3 = [],
        this.time3 = []

      },
      //  查询支护
      getData(){
        myHttp.selectHighModulusListPageNew({
          projectId: this.projectId
        }).then(resp => {
          if(resp.data.code === 200){
            this.list = resp.data.data
            if(!this.id){
              this.id = resp.data.data[0].id
              this.currentList = resp.data.data[0]
            }else{
              for(let i=0;i<this.list.length;i++){
                if(this.id == this.list[i].id){
                  this.currentList = this.list[i]
                }
              }
            }
            this.getHostList()
            
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      // 打开修改弹出框
      updateSupport(data){
        this.isUpdate = true
        this.fileList = []
        this.addForm.id = data.id
        this.addForm.name = data.name
        this.addForm.status = data.status
        this.addForm.safeLevel = data.safeLevel
        this.addForm.workDate = data.workDate
        this.addForm.remark = data.remark 
        if(data.planarGraph){
          let obj = {}
          obj.name = ''
          obj.url = data.planarGraph
          this.fileList.push(JSON.parse(JSON.stringify(obj)))
        }
        this.foundationDialog = true
      },

      
      //  添加/修改支护
       submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addForm.projectId = this.projectId
            if(this.addForm.id && this.addForm.id != ''){
              this.addForm.updateBy = util.session.get('user').id
              myHttp.updateHighModulusNew(this.addForm).then(resp => {
                if(resp.data.code === 200){
                  this.$message.success('修改成功！！')
                  this.foundationDialog = false
                  this.getData()
                }else{
                  this.$message.error(resp.data.msg)
                }
              })
            }else{
              this.addForm.createBy = util.session.get('user').id
              myHttp.postHighModulusNew(this.addForm).then(resp => {
                if(resp.data.code === 200){
                  this.$message.success('添加成功！！')
                  this.foundationDialog = false
                  this.getData()
                }
              })
            }
          } else {
            
            return false;
          }
        });
      },

      // 上传图片成功的回调
      successFile(resp, file, fileList){
        if(resp.code === 200){
          let obj = {}
          this.addForm.planarGraph = resp.data.saveUrls
          obj.name = file.name
          obj.url = resp.data.saveUrls
          this.fileList.push(JSON.parse(JSON.stringify(obj)))
        }else{
          this.$message.error(resp.msg)
        }
      },

      exceedFile(){
        this.$message.warning('只能上传一张照片！！')
      },

      // 打开添加支护弹出框
      addFoundation(){
        this.isUpdate = false
        this.addForm.id = ''
        this.addForm.name = ''
        this.addForm.status = ''
        this.addForm.safeLevel = ''
        this.addForm.workDate = ''
        this.addForm.remark = ''
        this.addForm.planarGraph = ''
        this.fileList = []
        this.foundationDialog = true
      }, 
      getSenserByDtuId(){
        let that = this
        myHttp.getSenserByDtuId({
          userType: util.session.get('roleId'),
          dtuId: this.id,
        }).then(res=>{
          console.log('获取了传感器')
          if(res.data.code==200){
            this.testList = []
            res.data.data.list.forEach(item=>{
              this.testList.push({
                left: 0,
                top: 0,
                name:item.name,
                id:item.id
              })
              that.btnclick(item)
            })
            this.getByIdentification()
            // that.aaa()
          }
        })
      },
      // 获取主机列表
      getHostList(){
        myHttp.selectTsDtuByDeepIdNew({
          dtuId: this.id,
          useType: 2,
          userType: util.session.get('roleId'),
          groupId: this.projectId
        }).then(resp => {
          if(resp.data.code === 200){
            this.hostData = resp.data.data
            if(this.hostData.length != 0){
              this.hostId = this.hostData[0].id
            }
            let ids = ''
            this.hostData.forEach(item => {
              ids = ids + ',' + item.id
            })
            ids = ids.slice(1)
            this.hostIdStr = ids
            // this.getCount(ids)
            this.getCount()
            this.getSenserByDtuId()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      //修改主机
      updateHost(row){
        this.addHostForm.id = row.id
        this.addHostForm.name = row.name
        this.addHostForm.dtuImei = row.dtuImei
        this.addHostDialog = true
      },

      // 打卡添加主机弹出框
      addHost(){
        this.addHostForm.id = ''
        this.addHostForm.dtuImei = ''
        this.addHostForm.name = ''
        this.addHostDialog = true
      },

      // 添加/修改主机
      submitHostForm(){
        this.addHostForm.groupId = this.projectId
        this.addHostForm.userType = util.session.get('roleId')
        this.addHostForm.dtuId = this.id
        if(this.addHostForm.id && this.addHostForm.id != ''){
          this.addHostForm.updateBy = util.session.get('user').id
          myHttp.updateTsDtuNew(this.addHostForm).then(resp => {
            if(resp.data.code === 200){
              this.$message.success('修改成功！！')
              this.addHostDialog = false
              this.getHostList()
            }else{
              this.$message.error(resp.data.msg)
            }
          })
        }else{
          this.addHostForm.createBy = util.session.get('user').id
          myHttp.addTsDtuNewNew(this.addHostForm).then(resp => {
            if(resp.data.code === 200){
              this.$message.success('添加成功！！')
              this.addHostDialog = false
              this.getHostList()
            }else{
              this.$message.error(resp.data.msg)
            }
          })
        }
      },

      // 行被展开时的回调
      expandChange(row, expandedRow){
        if(expandedRow.length){
          this.expands = []
          if(row){
            this.expands.push(row.id)
          }
        }else{
          this.expands = []
        }
        this.hostId = row.id
        clearTimeout(this.timer1)
        this.timer1 = null
        clearTimeout(this.timer2)
        this.timer2 = null
        clearTimeout(this.timer3)
        this.timer3 = null

        this.data1 = []
        this.wyData = [],
        this.warnData1 = [],
        this.time1 = [],
        this.data2 = [],  
        this.qjData = [[],[]],
        this.warnData2 = [[],[]],
        this.time2 = [],
        this.data3 = [],  
        this.ylData = [],
        this.warnData3 = [],
        this.time3 = [],

        this.getSensor()
      },

      getRowKey(row){
        return row.id
      },

      // 根据主机id获取传感器
      getSensor(){
        myHttp.queryTsDtuSensorListNew({
          tsDtuId: this.hostId
        }).then(resp => {
          if(resp.data.code === 200){
            this.data1 = []
            this.data2 = []
            this.data3 = []
            this.sensorList = resp.data.data.List
            this.sensorList.forEach(item => {
              if(item.tsSersorTypeName == '位移'){
                this.data1.push(item)
              }else if(item.tsSersorTypeName == '倾角'){
                this.data2.push(item)
              }else if(item.tsSersorTypeName == '压力'){
                this.data3.push(item)
              }
            })
            if(this.data1.length != 0){
              this.getChartData1(this.data1[0].id)
              this.currentData1 = this.data1[0]
            }
            if(this.data2.length != 0){
              this.getChartData2(this.data2[0].id)
              this.currentData2 = this.data2[0]
            }
            if(this.data3.length != 0){
              this.getChartData3(this.data3[0].id)
              this.currentData3 = this.data3[0]
            }
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      // 打开添加传感器弹出框
      addSensor(){
        this.addSensorForm.id = '',
        this.addSensorForm.name = '',
        this.addSensorForm.tsSersorImei = '',
        this.addSensorForm.tsSersorTypeid = ''
        this.addSensorForm.tsSersorType = ''
        this.addSensorDialog = true
      },

      // 修改传感器
      updateSensor(row){
        let type
        if(row.tsSersorTypeName == '位移'){
          type = 1
        }else if(row.tsSersorTypeName == '倾角'){
          type = 2
        }else if(row.tsSersorTypeName == '压力'){
          type = 3
        }
        this.addSensorForm.id = row.id
        this.addSensorForm.name = row.name
        this.addSensorForm.tsSersorImei = row.tsSersorImei
        this.addSensorForm.tsSersorType = type
        this.addSensorDialog = true
      },

      // 添加/修改传感器
      submitSensorForm(){
        this.addSensorForm.tsDtuId = this.hostId
        if(this.addSensorForm.id && this.addSensorForm.id != ''){
           this.addSensorForm.updateBy = util.session.get('user').id
           myHttp.uptTsDtuSensorNew(this.addSensorForm).then(resp => {
            if(resp.data.code === 200){
              this.$message.success('修改成功！！')
              this.addSensorDialog = false
              this.getSensor()
              this.getByIdentification()
            }else{
              this.$message.error(resp.data.msg)
            }
           })
        }else{
          this.addSensorForm.createBy = util.session.get('user').id
          myHttp.addTsDtuSensorNew(this.addSensorForm).then(resp => {
            if(resp.data.code === 200){
              this.$message.success('添加成功！！')
              this.addSensorDialog = false
              this.getSensor()
            }else{
              this.$message.error(resp.data.msg)
            }
          })
        }
      },

      // 打开预警值弹出框
      setValue(row){
        this.warnForm.warningValue = ''
        this.warnForm.tsSenserType = ''
        this.hostId = row.id
        this.warnValueDialog = true
      },

      // 提交预警值
      submitWarnForm(){
        this.warnForm.tsDtuId = this.hostId
        myHttp.senserWaringValueSetNew(this.warnForm).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('操作成功！！')
            this.warnValueDialog = false
            this.getSensor()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      // 获取个数
      getCount(ids){
        myHttp.selectCountById({
          projectId: this.projectId,
          userType: util.session.get('roleId'),
          dtuId: this.id,
          // tsDtuId: ids
        }).then(resp => {
          if(resp.data.code === 200){
            this.count = resp.data.data
          }
        })
      },


      // 删除支护
      deleteSupport(data){
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteHighModulusNew({
            id: data.id,
            updateBy: util.session.get('user').id
          }).then(resp => {
            if(resp.data.code === 200){
              this.$message.success('删除成功！！')
              this.getData()
            }else{
              this.$message.error(resp.data.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },

      // 删除主机   
      deleteHost(row){
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteTsDtuNew({
            id: row.id,
            updateBy: util.session.get('user').id
          }).then(resp => {
            if(resp.data.code === 200){
              this.$message.success('删除成功！！')
              this.getHostList()
            }else{
              this.$message.error(resp.data.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },

      // 删除传感器
      deleteSensor(row){
         this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteTsDtuSensorDTUNew({
            id: row.id,
            updateBy: util.session.get('user').id
          }).then(resp => {
            if(resp.data.code === 200){
              this.$message.success('删除成功！！')
              this.getSensor()
            }else{
              this.$message.error(resp.data.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      

      // 修改表头部样式
      tableHeaderStyle({row, column, rowIndex, columnIndex}){
        if(rowIndex == 0) {
          return 'background-color: #ECF0F5;'
        }
      },

      left1(){
        if(this.index1 <= 0 ){
          this.$message.warning('当前是第一个')
          return
        }

        this.time1 = []
        this.wyData = []
        this.warnData1 = []
        clearTimeout(this.timer1)
        this.timer1 = null

        this.index1--
        this.currentData1 = this.data1[this.index1]
        this.getChartData1(this.data1[this.index1].id)
      },
      right1(){
        if(this.index1 >= this.data1.length - 1){
          this.$message.warning('当前是最后一个')
          return
        }

        this.time1 = []
        this.wyData = []
        this.warnData1 = []
        clearTimeout(this.timer1)
        this.timer1 = null

        this.index1++
        this.currentData1 = this.data1[this.index1]
        this.getChartData1(this.data1[this.index1].id)
      },

       left2(){
        if(this.index2 <= 0 ){
          this.$message.warning('当前是第一个')
          return
        }

        this.time2 = []
        this.qjData = [[],[]]
        this.warnData2 = [[],[]]
        clearTimeout(this.timer2)
        this.timer2 = null

        this.index2--
        this.currentData2 = this.data1[this.index2]
        this.getChartData2(this.data2[this.index2].id)
      },
      right2(){
        if(this.index2 >= this.data2.length - 1){
          this.$message.warning('当前是最后一个')
          return
        }

        this.time2 = []
        this.qjData = [[],[]]
        this.warnData2 = [[],[]]
        clearTimeout(this.timer2)
        this.timer2 = null

        this.index2++
        this.currentData2 = this.data2[this.index2]
        this.getChartData2(this.data2[this.index2].id)
      },

       left3(){
        if(this.index3 <= 0 ){
          this.$message.warning('当前是第一个')
          return
        }

        this.time3 = []
        this.ylData = []
        this.warnData3 = []
        clearTimeout(this.timer3)
        this.timer3 = null

        this.index3--
        this.currentData3 = this.data3[this.index3]
        this.getChartData3(this.data3[this.index3].id)
      },
      right3(){
        if(this.index3 >= this.data3.length - 1){
          this.$message.warning('当前是最后一个')
          return
        }

        this.time3 = []
        this.ylData = []
        this.warnData3 = []
        clearTimeout(this.timer3)
        this.timer3 = null

        this.index3++
        this.currentData3 = this.data3[this.index3]
        this.getChartData3(this.data3[this.index3].id)
      },

      // 获取图表数据  位移
      getChartData1(id){
        myHttp.getSensorRecordNew({
          projectId: this.projectId,
          tsDtuSensorId: id
        }).then(resp => {
          if(resp.data.code === 200){
            const data = resp.data.data
            data.forEach(item => {
              if(item.displacement){
                if(this.wyData.length > 9){
                  this.wyData.shift()
                  this.wyData.push(item.displacement[0].offset)
                }else{
                  this.wyData.push(item.displacement[0].offset)
                }
                if(this.warnData1.length > 9){
                  this.warnData1.shift()
                  this.warnData1.push(item.displacement[0].warning)
                }else{
                  this.warnData1.push(item.displacement[0].warning)
                }
              }
            })
            if(this.time1.length > 9){
              this.time1.shift()
              this.time1.push(util.myTime.formatTime('','HH:mm:ss'))
            }else{
              this.time1.push(util.myTime.formatTime('','HH:mm:ss'))
            }
            this.timer1 = setTimeout(() => {
              this.getChartData1(id)
            }, 2000)
          }
        })
      },

      // 获取图表数据  倾角
      getChartData2(id){
        myHttp.getSensorRecordNew({
          projectId: this.projectId,
          tsDtuSensorId: id
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const data = resp.data.data
            data.forEach(item => {
              if(item.dipangle){
                console.log(this.qjData);
                if(this.qjData[0].length > 9){
                  this.qjData[0].shift()
                  this.qjData[1].shift()
                  this.qjData[0].push(item.dipangle[0].offset)
                  this.qjData[1].push(item.dipangle[0].strain)
                }else{
                  this.qjData[0].push(item.dipangle[0].offset)
                  this.qjData[1].push(item.dipangle[0].strain)
                  console.log(this.qjData);
                }
                if(this.warnData2[0].length > 9){
                  this.warnData2[0].shift()
                  this.warnData2[1].shift()
                  this.warnData2[0].push(item.dipangle[0].warning.split(',')[0])
                  this.warnData2[1].push(item.dipangle[0].warning.split(',')[0])
                }else{
                  this.warnData2[0].push(item.dipangle[0].warning.split(',')[0])
                  this.warnData2[1].push(item.dipangle[0].warning.split(',')[0])
                }
              }
            })
            if(this.time2.length > 9){
              this.time2.shift()
              this.time2.push(util.myTime.formatTime('','HH:mm:ss'))
            }else{
              this.time2.push(util.myTime.formatTime('','HH:mm:ss'))
            }
            this.timer2 = setTimeout(() => {
              this.getChartData2(id)
            }, 2000)
          }
        })
      },

      // 获取图表数据  压力
      getChartData3(id){
        myHttp.getSensorRecordNew({
          projectId: this.projectId,
          tsDtuSensorId: id
        }).then(resp => {
          if(resp.data.code === 200){
            const data = resp.data.data
            data.forEach(item => {
              if(item.pressure){
                if(this.ylData.length > 9){
                  this.ylData.shift()
                  this.ylData.push(item.pressure[0].offset)
                }else{
                  this.ylData.push(item.pressure[0].offset)
                }
                if(this.warnData3.length > 9){
                  this.warnData3.shift()
                  this.warnData3.push(item.pressure[0].warning)
                }else{
                  this.warnData3.push(item.pressure[0].warning)
                }
              }
            })
            if(this.time3.length > 9){
              this.time3.shift()
              this.time3.push(util.myTime.formatTime('','HH:mm:ss'))
            }else{
              this.time3.push(util.myTime.formatTime('','HH:mm:ss'))
            }
            this.timer3 = setTimeout(() => {
              this.getChartData3(id)
            }, 2000)
          }
        })
      },

      initChart1(){
        let chart1 = this.$echarts.init(this.$refs.chart1)
        setInterval(() => {
          chart1.setOption({
            xAxis: {
              data: this.time1
            },
            series: [
              {
                data: this.wyData
              }
            ]
          });
        }, 2001);
        chart1.setOption({
          color: ['#80FFA5'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            right: '3%'
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.time1,
              axisLabel: {
                show: true,
                interval: 0
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '位移',
              type: 'line',
              stack: 'Total',
              smooth: true,
              lineStyle: {
                width: 0
              },
              showSymbol: false,
              areaStyle: {
                opacity: 0.8,
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgb(0, 221, 255)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(77, 119, 255)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: this.wyData
            },
          ]
        })
      },

       initChart2(){
        let chart2 = this.$echarts.init(this.$refs.chart2)
        setInterval(() => {
          chart2.setOption({
            xAxis: {
              data: this.time2
            },
            series: [
              {
                data: this.qjData[0]
              },
              {
                data: this.qjData[1]
              }
            ],
          });
        }, 2001);
        chart2.setOption({
          color: ['#80FFA5'],
          tooltip: {
            trigger: 'axis',
            textStyle: {
              textAlign: 'left',
            },
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            right: '3%'
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.time2,
              axisLabel: {
                show: true,
                interval: 0
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '倾角数据1',
              type: 'line',
              stack: 'Total',
              smooth: true,
              lineStyle: {
                width: 0
              },
              showSymbol: false,
              areaStyle: {
                opacity: 0.8,
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgb(0, 221, 255)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(77, 119, 255)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: this.qjData[0]
            },
            {
              name: '倾角数据2',
              type: 'line',
              stack: 'Total',
              smooth: true,
              lineStyle: {
                width: 0
              },
              showSymbol: false,
              areaStyle: {
                opacity: 0.8,
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgb(0, 221, 255)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(77, 119, 255)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: this.qjData[1]
            },
          ]
        })
      },

       initChart3(){
        let chart3 = this.$echarts.init(this.$refs.chart3)
        setInterval(() => {
          chart3.setOption({
            xAxis: {
              data: this.time3
            },
            series: [
              {
                data: this.ylData
              }
            ]
          });
        }, 2001);
        chart3.setOption({
          color: ['#80FFA5'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            right: '3%'
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.time3,
              axisLabel: {
                show: true,
                interval: 0
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '压力',
              type: 'line',
              stack: 'Total',
              smooth: true,
              lineStyle: {
                width: 0
              },
              showSymbol: false,
              areaStyle: {
                opacity: 0.8,
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgb(0, 221, 255)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(77, 119, 255)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: this.ylData
            },
          ]
        })
      },

      // 去历史数据
      toHistory(){
        if(this.hostData.length == 0){
          this.$message.warning('当前暂无主机！！')
          return
        }
        this.$router.push({
          path: '/historyListNew',
          query: {
            ids: this.hostIdStr,
            id: this.id,
            type:1
          }
        })
      }
    },
    beforeDestroy(){
      clearTimeout(this.timer1)
      this.timer1 = null
      clearTimeout(this.timer2)
      this.timer2 = null
      clearTimeout(this.timer3)
      this.timer3 = null
    }
  }
</script>

<style scoped>
.SourceHanSansCN-Regular{
  font-family: 'SourceHanSansCN-Regular';
}
.content{
  display: flex;
  flex-direction: row;
}
.content-left{
  width: 240px;
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  margin-right: 1vw;
}
.content-right{
  flex: 1;
  height: 100%;
  overflow: auto;
  margin-right: 0.5vw;
}
.aside-top{
  padding: 1.5vh 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #E7E7E7;
  color: #666;
}
.button{
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  text-align: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff!important;
}
.button2:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.button-red:hover{
  background-color: #F56C6C;
  color: #fff!important;
}
.aside-list{
  padding: 0 5px;
  height: calc(100% - 60px);
  overflow-y: auto;
}
.foundation-item{
  box-sizing: border-box;
  height: 72px;
  border-radius: 6px;
  background: #E5E5E5;
  margin-top: 2px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.foundation-item:hover{
  background-color: #E4ECFC!important;
}
.foundation-item-active{
  background-color: #E4ECFC!important;
}
.item-left{
  width: 70%;
  font-size: 18px;
  font-weight: 350;
  letter-spacing: 0em;
  color: #8E8E8E;
}
.foundation-detail{
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  margin-bottom: 2vh;
}
.title{
  padding: 14px;
  color: #666;
  font-size: 16px;
  text-align: left;
  border-bottom: 2px solid #E7E7E7;;
}
.info{
  padding: 3vh 14px;
  font-size: 18px;
}
.foundation-ichnography{
  position: relative;
  height: 64.5vh;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.foundation-ichnography-img{
  height: 20vh;
  /* padding-top: 20px; */
  background-color: #fff;
  position: relative;
}
.popover-item{
  width: 90px;
  height: 28px;
  border-radius: 6px;
  color: #9E9E9E;
  font-size: 16px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}
.popover-item:hover{
  background: #E4ECFC;
}
.content >>> .el-icon-close:before{
  content: '';
}
.content >>> .el-dialog__header{
  padding: 0;
}
.content >>> .el-dialog{
  border-radius: 6px;
}
.dialog-title{
  height: 48px;
  background: #ECF0F5;
  font-size: 16px;
  color: #666;
  border-radius: 6px 6px 0px 0px;
  line-height: 48px;
}
.content >>> .el-form-item__label{
  font-family: 'SourceHanSansCN-Regular';
  font-size: 14px;
  color: #9E9E9E;
}
.content >>> .el-input__inner{
  width: 300px;
}
.content >>> .el-textarea__inner{
  width: 300px;
}
.upload-div{
  width: 100px;
  height: 100px;
  border-radius: 6px;
  background: rgba(77, 110, 177, 0.05);
  box-sizing: border-box;
  border: 1px dashed #DEDEDE;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-engine-list{
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  margin-bottom: 2vh;
}
.table{
  padding: 20px 5px 5px;
}
.table-button{
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-family: 'SourceHanSansCN-Regular';
  font-size: 14px;
  cursor: pointer;
}
.expand-top{
  position: relative;
  margin-top: 1vh;
  background: rgba(236, 240, 245, 0.6);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
}
.table >>> .el-table__expanded-cell{
  padding: 20px 0;
}
.five-icons {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2vh;
}
.five-icons > div{
  width: 19%;
  height: 150px;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.icon-item-right{
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'SourceHanSansCN-Regular';
}
.icon-item-right p:nth-child(1){
  font-size: 40px;
  color: #000000;
}
.icon-item-right p:nth-child(2){
  font-size: 18px;
  color: #999999;
}
.liquid-level-gauge, .inclinometer{
  position: relative;
  height: 450px;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  margin-bottom: 2vh;
}
.foundation-ichnography-img{
  height: 712px;
}
.content >>> .el-table__expand-icon{
  height: 24px;
}
.content >>> .el-table__expand-icon:after{
  display: inline-block;
  position: relative;
  content: '展开';
  cursor: pointer;
  color: #8EA3CE;
  border:1px solid rgba(153, 153, 153, 0.8);
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  font-size: 14px;
}
.content >>>.el-table__expand-column{
  height: 56px;
  border-right: none !important;
}
.content >>> .el-table__expand-icon--expanded{
  transform: none;
}
.content >>> .el-table__expand-icon>.el-icon{
  display: none;
}
.content >>> .el-table_1_column_8{
  border-right: none;
}
/* .content >>>.el-table__expand-column>.cell{
  height: 100% !important;
  width: 100% !important;
  padding: 0 !important;
}
.content >>> .el-table_1_column_8 > .cell{
  height: 25px;
  width: 60px;
} */
.el-icon-arrow-left{
  position: absolute;
  font-size: 40px;
  color: #666;
  top: 226px;
  left: 0;
  cursor: pointer;
}
.el-icon-arrow-right{
  position: absolute;
  font-size: 40px;
  color: #666;
  top: 226px;
  right: 0;
  cursor: pointer;
}
.content >>> .el-table--border, .el-table--group{
  border: 1px solid #EBEEF5;
}
.bg-color1{
  background-color: #fff;
}
.bg-color2{
  background-color: #E5E5E5;
}
.content >>> .cell{
  font-size: 14px;
}
.content >>> .el-table td.el-table__cell div{
  font-size: 14px;
}
.cebian{
  position: absolute;
  background-color: rgba(255,255,255,0.8);
  height: 100%;
  width:0 ;
  left: 0;
  top: 0;
  /* overflow: auto; */
  transition: width 0.3s;
  z-index: 200;
}
.cebian>div{
  position: absolute;
    right: -16px;
    width: 16px;
    height: 43px;
    top: 41%;
    background: rgb(77,110,177);
    display: flex;
    align-items: center;
    z-index: 199;
}
.cebian-item{
  width: 12%;
  background-color: #fff;
  font-size: 14px;
  height: 5vh;
  line-height: 5vh;
  margin-top: 0.6vh;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 200;
  opacity: 0;
}
.iconItem{
  width: 20px;
  height: 20px;
  background-color: #f00;
  
}
.cebian-item:hover{
  cursor: pointer;
  background-color: #4D6EB1;
  color:#fff;
}
.box5-cont{
  width:100%;
  height:82vh;
  position: relative;
}
  .iconFt{
        width: 13%;
    height: 13%;
    position: absolute;
    /* border: 1px solid; */
    z-index: 199;
  }
  .iconFt>div:nth-child(2){
        height: 38%;
    width: 19%;
    margin: 5% 23%;
    border-radius: 50%;
    background: rgb(98,170,252);
  }
  .iconFt>div:nth-child(3){
    position: absolute;
    right: -3%;
    top: -6%;
    cursor: pointer;
  }
  .iconFt>div:nth-child(1){
    width: 100%;
    font-size: 12px;
    background: #fff;
    height: 42px;
    line-height: 42px;
    position: relative;
    border-radius: 5px;
    /* overflow: hidden; */
    white-space:nowrap;
    text-overflow: ellipsis;
  }
  .iconFt>div:nth-child(1)::before{
    content: "";
    position: absolute;
    left: 54px;
    bottom: -7px;
    width: 0;
    height: 0;
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
    border-top: 8px solid #fff;
    z-index: 400;
  }
</style>

<style>
.el-popover {
  min-width: 100px!important;
  padding: 12px 5px!important;
}
</style>